import ScoreIndicator from "@/components/score-indicator";
import Image from "next/image";
import Link from "next/link";
import { MdPlayArrow } from "react-icons/md";
import { SiCodeigniter } from "react-icons/si";
import { cn } from "@/lib/utils";
import { useCurrencyRate } from "@hooks/useCurrencyRate";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

type ExperienceCardProps = {
  id: string;
  onClick: () => void;
  title: string;
  score: number;
  price: number;
  currency: number;
  symbol: string;
  imgUrl: string;
  isPopular: boolean;
};

export default function ExperienceCard({
  id,
  onClick,
  title,
  score,
  price,
  currency,
  symbol,
  imgUrl,
  isPopular,
}: ExperienceCardProps) {

  const { t } = useTranslation();

  return (
    <div
      id={id}
      className={cn(
        "relative flex flex-col justify-between items-center w-full lg:w-[22vw] max-w-[280px] h-[40vh] lg:h-[405px] sm:h-[45vh] rounded-2xl cursor-pointer border-2 md:border-4 mx-auto",
        isPopular ? "border-primary-color" : "border-gray-100"
      )}
      onClick={onClick}
    >
      <Image
        src={imgUrl}
        alt=""
        className="absolute object-cover w-full h-full rounded-xl"
        fill
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        quality={80}
      />
      <div className="z-10 flex items-center justify-center w-full h-20 text-center text-white bg-gradient-to-b from-black rounded-2xl">
        <h3 className={"text-sm md:text-[0.9rem] mx-2 font-bold tracking-wider"}>
          {title}
        </h3>
      </div>
      <div
        className={
          "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-10 h-10 md:w-11 md:h-11 p-2 border border-gray-100 rounded-full bg-gray-900/60"
        }
      >
        <MdPlayArrow className="w-full h-full text-gray-100" />
      </div>

      <div className="z-10 flex justify-between items-end px-0.5 w-full">
        <div>
          {isPopular && (
            <div className="py-1 px-0.5 mb-1">
              <div className="w-10 h-10 md:w-12 md:h-12 :h-12 mb-1 mx-auto">
                <SiCodeigniter className="w-full h-full bg-black rounded-full border-2 border-primary-color text-primary-color p-2" />
              </div>
              <div className="text-tiny md:text-xs py-1.5 px-0.5 rounded-md text-black bg-primary-color bg-opacity-90 uppercase flex justify-center items-center font-bold">
                {t('TRENDING')}
              </div>
            </div>
          )}
        </div>
        <div className="flex justify-between items-center mb-1 bg-[#121212]/80 border border-gray-600 rounded-xl p-1 gap-0.5">
          <div className="w-8 md:w-9 text-tiny md:text-[9px] text-[10px]">
            <ScoreIndicator score={score} />
          </div>
          <p className="text-tiny md:text-xs pl-0.5 :pl-2 md:pl-2 flex items-center justify-between font-semibold text-primary-color">
            <span className="text-right">
              <span className="font-light text-white">{t('FROM')}</span>
              <span className="text-sm md:text-[1.05rem]">
                {` ${Math.round(currency* (Number((isNaN(+price) ? "0" : +price)))) + symbol}`}
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
